(function () {
  const opener = document.querySelector('.product-size-chart__opener');
  const target = document.querySelector('.shopify-payment-button');

  if (!opener || !target) return;

  let ticking = false;
  const MIN_BOTTOM = 32; // 2rem — resting position when the target is out of view
  const EDGE_MARGIN = 32;

  function update() {
    ticking = false;
    const rect = target.getBoundingClientRect();
    const desired = window.innerHeight - rect.bottom;
    const maxBottom = Math.max(window.innerHeight - opener.offsetHeight - EDGE_MARGIN, MIN_BOTTOM);
    opener.style.bottom = `${Math.min(Math.max(desired, MIN_BOTTOM), maxBottom)}px`;
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  if (window.ResizeObserver) {
    new ResizeObserver(requestUpdate).observe(target);
  }

  update();
})();
